<template>
  <div ref="div1" class="stationfilter" style="height: 100%; width: 100%">
    <el-row>
      <el-col :span="24">
        <el-input
          placeholder="输入关键字进行过滤"
          v-model="filterText"
          clearable
        ></el-input>
      </el-col>
    </el-row>
    <el-scrollbar style="height: calc(100% - 60px); width: 100%">
      <el-tree
        ref="tree"
        empty-text="暂无数据"
        node-key="id"
        :data="data"
        default-expand-all
        :filter-node-method="filterNode"
        :show-checkbox="showbox"
        @check-change="checkChange"
        @current-change="curChange"
        check-on-click-node
        :expand-on-click-node="false"
        :default-checked-keys="defaultCheck"
        :highlight-current="true"
      >
        <template slot-scope="scope">
          <div
            :class="{ 'text-blue': scope.data.id == curNodeid }"
            :title="scope.data.label"
          >
            <i v-if="scope.data.type == 'station'" class="el-icon-place"></i>
            <i
              v-else-if="scope.data.type == 'catalog'"
              class="el-icon-coin"
            ></i>
            <i v-else class="el-icon-menu"></i>
            <span>{{ scope.data.label }}</span>
          </div>
        </template>
      </el-tree>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  name: "stationfilter",

  props: {
    singlecheck: {
      type: Boolean,
      default: false,
    },
    //默认多选站点的数量
    selectCount: {
      type: Number,
      default: 2,
    },
  },
  created() {
    // this.getStationList();
  },
  mounted() {
    this.getStationList();
    if (this.singlecheck) {
      this.showbox = false;
    }
  },
  watch: {
    //根据关键词过滤节点
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      checkedId: "",
      filterText: "",
      data: [],
      //选中的节点信息
      selectedNodes: [],
      //默认选中的节点
      defaultCheck: [],
      selectedKeys: [],
      showbox: true,
      curNodeid: "",
      curNodename: "",
    };
  },
  methods: {
    //节点过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //获取站点树形数据
    getStationList() {
      let _this = this;
      this.$api.get(
        "/Station/GetStationTree",
        null,
        function (res) {
          if (res.code == 200) {
            let tempData = [
              { label: "全部", id: "0", dataType: "", children: [] },
            ];
            let tempType = [];
            let mulId = [];
            let mulLabel = [];
            for (let i = 0; i < res.data.type.length; i++) {
              //字典库的站点类型
              let item = res.data.type[i];
              //根据站点类型，获取该站点类型下的站点children
              var children = res.data.stations.filter(
                (t) => t.StationType == item.DictionaryName
              );
              //某个站点类型的子节点
              let tempChildren = [];
              //多选站点的ID集合
              if (children.length > 0) {
                for (let j = 0; j < children.length; j++) {
                  let itema = children[j];
                  if (j == 0 && i == 0 && _this.singlecheck) {
                    //单选默认选中
                    _this.curNodeid = itema.id;
                    _this.curNodename = itema.label;
                    _this.$emit("loaded", [itema.label]);
                  }
                  tempChildren.push({
                    id: itema.id,
                    label: itema.label,
                    type: "station",
                  });
                  //多选时，默认要加载第一个父节点的前两个站点
                  if (mulId.length < _this.selectCount) {
                    mulId.push(itema.id);
                    mulLabel.push(itema.label);
                  }
                }
                tempType.push({
                  id: item.ID,
                  label: item.DictionaryName,
                  children: tempChildren,
                  type: "catalog",
                });
              }
            }
            tempData[0].children = tempType;
            _this.data = tempData;
            //可多选站点 默认选中前两个站点
            if (!_this.singlecheck) {
              _this.defaultCheck = mulId;
              _this.$emit("loaded", mulLabel);
            }
          }
        },
        function () {},
        true
      );
    },
    //选中项变化
    checkChange(node, checkState, childrenCheckState) {
      if (!this.singlecheck) {
        let nodes = this.$refs.tree.getCheckedNodes();
        this.selectedNodes = nodes;
        this.setSelectedStations(nodes);
      }
    },
    //添加选中的站点
    setSelectedStations(nodes) {
      let arr = [];
      for (let i = 0; i < nodes.length; i++) {
        let item = nodes[i];
        if (item.type == "station") {
          arr.push(item.label);
        }
      }
      this.selectedKeys = arr;

      if (this.singlecheck) {
        this.$emit("checkchange", this.curNodename);
      }
      this.$emit("checkchange", this.selectedKeys);
    },
    curChange(data, node) {
      if (this.singlecheck && data.type == "station") {
        this.curNodeid = data.id;
        this.curNodename = data.label;
        let arr = [];
        arr.push(this.curNodename);
        this.$emit("checkchange", arr);
      }
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}
.tree-node-icon {
  margin-right: 5px;
  font-size: 18px;
  color: #48c9a2;
}
.text-blue {
  color: rgb(255, 151, 31);
  i {
    color: rgb(255, 151, 31);
  }
}
/deep/.el-tree-node__content {
  height: 30px;
}
i {
  margin-right: 4px;
  color: @basecolor;
}
</style>